import { render } from "./IconInternalTransfer.vue?vue&type=template&id=3ffd6134"
import script from "./IconInternalTransfer.vue?vue&type=script&lang=js"
export * from "./IconInternalTransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconInternalTransfer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ffd6134"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ffd6134', __exports__)) {
    api.reload('3ffd6134', __exports__)
  }
  
  module.hot.accept("./IconInternalTransfer.vue?vue&type=template&id=3ffd6134", () => {
    api.rerender('3ffd6134', render)
  })

}


export default __exports__